import assignOrganization from './assignOrganization';
import assignAddress from './assignAddress';
import Entity from '../../schema/Entity';
import EntityType from '../../schema/innerSchema/EntityType';
import EntityTypeNames from '../../schema/innerSchema/EntityTypeNames';
import ParcelDelivery from '../../schema/ParcelDelivery';
import checkEntityArray from './checkEntityArray';

/**
 * parse data for ParselDelivery Entity
 */
export default function setParcelDeliveryEntityData(
    entity: Entity,
    parcelEntity: any,
    isValidDate?: (dateTime: string, isUtcTime: boolean, entity?: Entity) => boolean
): ParcelDelivery {
    if (entity && parcelEntity) {
        if (isParcelDeliveryValid(parcelEntity, entity, isValidDate)) {
            let partOfOrder = checkEntityArray(parcelEntity.partOfOrder);
            let seller = partOfOrder.seller;

            // assign the parcel Delivery data
            let newParcelEntity: ParcelDelivery = {
                ...entity,
                ...{
                    entityName: EntityTypeNames.ParcelDelivery,
                    entityType: EntityType.ParcelDelivery,
                    trackingUrl: parcelEntity.trackingUrl,
                    trackingNumber: parcelEntity.trackingNumber,
                    expectedArrivalFrom: parcelEntity.expectedArrivalFrom,
                    expectedArrivalUntil: parcelEntity.expectedArrivalUntil,
                    expectedArrivalUntilUtc: parcelEntity['expectedArrivalUntil/utc'],
                    deliveryAddress: {},
                    partOfOrder: {
                        orderNumber: partOfOrder.orderNumber,
                        orderStatus: partOfOrder.orderStatus,
                        seller: {
                            name: seller.name,
                            telephone: seller.telephone,
                        },
                    },
                },
            };

            // assign provider
            newParcelEntity.provider = assignOrganization({}, parcelEntity.provider);

            // assign address
            newParcelEntity.deliveryAddress = assignAddress({}, parcelEntity.deliveryAddress);

            // assign item details
            let orderedItem = checkEntityArray(parcelEntity.partOfOrder.orderedItem);
            if (orderedItem) {
                newParcelEntity.partOfOrder = {
                    ...newParcelEntity.partOfOrder,
                    ...{
                        orderedItem: {
                            url: orderedItem.url,
                            name: orderedItem.name,
                            sku: orderedItem.sku,
                            description: orderedItem.description,
                            brand: orderedItem.brand,
                            color: orderedItem.color,
                        },
                    },
                };
            }

            return newParcelEntity;
        }
    }
    return null;
}

export function isParcelDeliveryValid(
    parcelEntity: any,
    entity: Entity,
    isValidDate?: (dateTime: string, isUtcTime: boolean, entity?: Entity) => boolean
) {
    if (parcelEntity) {
        let isExpectedArrivalFromDateValid: boolean = true;
        let isExpectedArrivalUntilDateValid: boolean = true;

        if (isValidDate) {
            isExpectedArrivalFromDateValid = isValidDate(
                parcelEntity.expectedArrivalFrom,
                false /* isUtcTime*/,
                entity
            );
            isExpectedArrivalUntilDateValid = isValidDate(
                parcelEntity.expectedArrivalUntil,
                false /* isUtcTime*/,
                entity
            );
        }

        let partOfOrder = checkEntityArray(parcelEntity.partOfOrder);
        if (
            partOfOrder?.seller?.name &&
            ((parcelEntity.expectedArrivalFrom && isExpectedArrivalFromDateValid) ||
                (parcelEntity.expectedArrivalUntil && isExpectedArrivalUntilDateValid))
        ) {
            return true;
        }
    }
    return false;
}
